import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "px-2 py-5 scenario-share" }, [
      _createElementVNode("h1", { class: "mt-5" }, "Preparing visit feedback..."),
      _createElementVNode("h3", null, "Please stay in Zoom Session."),
      _createElementVNode("h4", null, "Thank you.")
    ], -1)
  ])))
}